import {
    FileXIcon,
    PrinterCheckIcon,
} from "../../components/Icons";
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import ChecklistIcon from "@mui/icons-material/Checklist";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptIcon from '@mui/icons-material/Receipt';


const IconButton = ({ label }) => {
    return (
        <>
            {label.includes("Incompleta") && <FileXIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Aprobar") && <CheckCircleIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Notificar") && <FileDownloadDoneIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Editar") && <EditNoteIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Completar") && <ChecklistIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Impresa") && <PrinterCheckIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Asignar") && <PersonAddIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Desasignar") && <PersonRemoveIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Reasignar") && <PersonRemoveIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Descargo") && <FileDownloadDoneIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Anular") && <DoDisturbAltIcon width={24} height={24} strokeWidth={1.6} />}
            {(label.includes("Constancia") && label != "Constancia anulación") && <DescriptionIcon width={24} height={24} strokeWidth={1.6} />}
            {label.includes("Recibo") && <ReceiptIcon width={24} height={24} strokeWidth={1.6} />}

        </>
    );
}
export default IconButton;